export default __webpack_public_path__ + "static/media/Wounded-Warrior.40ac172b.jpg";